import { ListPathQuestionSchemaType } from '../generated/types.js';

/**
 * Should the node auto submit when questions are answered
 */

function doesNodeAutomaticallySubmit(questionCommands, questionViewModel) {
  var _a, _b;
  /**
   * We only submit the page if there is one question
   */


  if (questionViewModel.questions.length > 1) {
    return false;
  }
  /**
   * Criteria to otherwise auto-submit a node:
   *
   *   1. Is the only question a single select list question?
   *   2. Has the question been previously answered (are we moving backward)?
   *   3. Is there a valid representation of the question command in state (has it been answered)?
   */


  var questionReference = questionViewModel.questions[0];

  if (questionReference.__typename === 'ListQuestionPathNodeFlowViewModel') {
    var isSingleSelect = questionReference.listSchemaType === ListPathQuestionSchemaType.SINGLE_SELECT_LIST;
    var hasQuestionBeenAnswered = questionReference.choices.find(function (choice) {
      return choice.selected;
    });

    if (isSingleSelect && !hasQuestionBeenAnswered) {
      var referencedCommand = questionCommands[questionReference.id];

      if (referencedCommand) {
        return ((_a = referencedCommand.listQuestion) === null || _a === void 0 ? void 0 : _a.values) && ((_b = referencedCommand.listQuestion) === null || _b === void 0 ? void 0 : _b.values.length) > 0;
      }
    }
  }

  return false;
}

export default doesNodeAutomaticallySubmit;
//# sourceMappingURL=doesNodeAutomaticallySubmit.js.map
